import { useChatList } from './api/chat'

type UseHasChatTripPlannerChatsResult = {
  hasChatTripPlannerChats: boolean
  hasChatTripLookupError: boolean
  isLoadingChatTripPlannerChats: boolean
}

function useHasChatTripPlannerChats(enabled = true): UseHasChatTripPlannerChatsResult {
  const {
    data: chats = [],
    isError,
    isFetching,
    isFetched,
  } = useChatList({ enabled })

  return {
    hasChatTripPlannerChats: chats.length > 0,
    hasChatTripLookupError: isError,
    isLoadingChatTripPlannerChats: isFetching && !isFetched,
  }
}

export default useHasChatTripPlannerChats
